import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError(err => {
      if (err.status === 401) {
        router.navigate(['/']);
      }

      if (err.status === 403) {
        const message = err.error?.message || 'You do not have permission to perform this action.';
        alert(message);
        router.navigate(['/']);
        return throwError(() => ({ status: err.status, message }));
      }

      const status = err.status;
      let message: string;
      if (status >= 500) {
        message = 'Server error. Please try again later.';
      } else if (status === 429) {
        message = 'Too many requests. Please try again later.';
      } else if (status === 422) {
        message = 'Validation failed. Please check your input.';
      } else if (status === 404) {
        message = 'Resource not found.';
      } else if (status === 401) {
        message = 'Session expired. Please login again.';
      } else if (status === 400) {
        message = 'Invalid request. Please check your input.';
      } else {
        message = 'Something went wrong. Please try again.';
      }
      return throwError(() => ({ status, message }));
    })
  );
};
